// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"d9874a33","318":"d203e6e2","325":"9007bfdf","453":"37480376","864":"7c13d1a3"}[chunkId] + ".chunk.js";
};